import React from 'react';
import {
  Box,
  Paper,
  Typography,
  Button,
} from '@mui/material';
import {
  Cancel as CancelIcon,
  Print as PrintIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
} from '@mui/icons-material';
import { canCancelOrder } from '../../utils/orderUtils';

/**
 * Composant pour la barre d'actions des commandes sélectionnées
 */
const SelectedOrdersActions = ({
  selectedOrders,
  orders,
  isAdmin,
  onBulkCancel,
  onPrint,
  onBulkStatusChange,
  onBulkDelete,
}) => {
  if (selectedOrders.size === 0) {
    return null;
  }

  return (
    <Paper sx={{ p: 2, mb: 3, backgroundColor: '#1E1E1E', color: 'white' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="body1" fontWeight="medium">
          {selectedOrders.size} commande(s) sélectionnée(s)
        </Typography>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button
            variant="contained"
            color="primary"
            size="small"
            startIcon={<PrintIcon />}
            onClick={onPrint}
          >
            Imprimer ({selectedOrders.size})
          </Button>
          <Button
            variant="contained"
            color="secondary"
            size="small"
            startIcon={<EditIcon />}
            onClick={onBulkStatusChange}
          >
            Changer statut
          </Button>
          <Button
            variant="contained"
            color="error"
            size="small"
            startIcon={<CancelIcon />}
            onClick={onBulkCancel}
            disabled={!Array.from(selectedOrders).some(id =>
              canCancelOrder(orders.find(order => order.id === id))
            )}
          >
            Annuler les commandes
          </Button>
          {isAdmin && onBulkDelete && (
            <Button
              variant="outlined"
              color="error"
              size="small"
              startIcon={<DeleteIcon />}
              onClick={onBulkDelete}
            >
              Supprimer ({selectedOrders.size})
            </Button>
          )}
        </Box>
      </Box>
    </Paper>
  );
};

export default SelectedOrdersActions;
